import { createReducer, on } from '@ngrx/store';
import { productsSyncActions } from '../actions/products-sync.actions';
import { SyncLog } from '../models';

export interface ProductsSyncState {
    syncLog: SyncLog | null;
    syncing: boolean;
    loaded: boolean | null;
    loading: boolean | null;
    saving: boolean;
    saved: boolean;
    polling: boolean;
}

const initialState: ProductsSyncState = {
    syncLog: null,
    syncing: true,
    loaded: null,
    loading: null,
    saving: false,
    saved: false,
    polling: false,
};

export const productsSyncReducer = createReducer(
    initialState,
    on(
        productsSyncActions.syncItems,
        (state): ProductsSyncState => ({
            ...state,
            saving: true,
            saved: false,
        }),
    ),
    on(
        productsSyncActions.syncItemsSuccess,
        (state): ProductsSyncState => ({
            ...state,
            saving: false,
            saved: true,
            syncing: true,
        }),
    ),
    on(
        productsSyncActions.syncItemsError,
        (state): ProductsSyncState => ({
            ...state,
            saving: false,
            saved: false,
        }),
    ),
    on(
        productsSyncActions.getSyncStatus,
        (state): ProductsSyncState => ({
            ...state,
            loading: true,
            loaded: null,
        }),
    ),
    on(
        productsSyncActions.getSyncStatusSuccess,
        (state, { payload }): ProductsSyncState => ({
            ...state,
            loading: false,
            loaded: true,
            syncing: payload.status === 'running',
            syncLog: payload,
        }),
    ),
    on(
        productsSyncActions.getSyncStatusError,
        (state): ProductsSyncState => ({
            ...state,
            loading: false,
            loaded: false,
            syncing: false,
        }),
    ),
    on(
        productsSyncActions.getSyncStatusQuiet,
        (state): ProductsSyncState => ({
            ...state,
            polling: true,
        }),
    ),
    on(
        productsSyncActions.getSyncStatusQuietSuccess,
        (state, { payload }): ProductsSyncState => ({
            ...state,
            polling: false,
            syncing: payload.status === 'running',
            syncLog: payload,
        }),
    ),
    on(
        productsSyncActions.getSyncStatusQuietError,
        (state): ProductsSyncState => ({
            ...state,
            polling: false,
            syncing: false,
        }),
    ),
    on(productsSyncActions.clear, (): ProductsSyncState => initialState),
);
